module.exports = __webpack_public_path__ + "static/media/cg.029abdbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/safetyTrainingCourses/record/images/cg.png
// module id = 1547
// module chunks = 0